export default function AutresMarques() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Les autres marques que nous traitons
        </h2>
        <p className="text-brand-text leading-relaxed mb-5">
          Au-delà de Bubendorff, nos équipes interviennent sur tous les moteurs de volets roulants du marché. Nous remplaçons régulièrement des moteurs Somfy, Nice, Faac, Came, Simu et autres fabricants européens. Chaque marque possède ses spécificités techniques : Somfy domine le marché avec ses protocoles RTS et IO-Homecontrol, Nice propose des solutions robustes pour les grandes baies vitrées, tandis que Faac et Came sont très présents dans les installations collectives. Cette polyvalence nous permet de vous proposer une alternative si le moteur Bubendorff d&apos;origine n&apos;est plus disponible.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          Lorsqu&apos;un client possède plusieurs volets de marques différentes, nous pouvons homogénéiser l&apos;ensemble des commandes en installant un système centralisé compatible multi-marques. Cette approche est particulièrement utile pour les maisons équipées de volets Bubendorff à l&apos;arrière et de volets Somfy à l&apos;avant, par exemple. Nous proposons alors des modules de commande universels qui permettent de piloter tous les volets depuis une seule télécommande ou une application smartphone. Notre stock de pièces détachées couvre les principales gammes de moteurs, ce qui garantit une réparation rapide sans attendre des délais d&apos;approvisionnement.
        </p>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Marques couvertes par notre service
        </h3>
        <ul className="space-y-3">
          {[
            "Moteurs Somfy : remplacement et reprogrammation RTS / IO-Homecontrol",
            "Moteurs Nice : diagnostic et changement pour volets lourds et grandes baies",
            "Moteurs Faac et Came : intervention sur installations collectives et tertiaires",
            "Moteurs Simu, Becker et Profalux : remplacement avec conservation des commandes",
            "Moteurs universels compatibles : solution économique pour volets anciens",
            "Migration multi-marques : centralisation des commandes sous un seul protocole",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}